import React from 'react';
import { Linking } from 'react-native';

import ClosingBand from '@/components/Landing/ClosingBand';
import { Accent, useLanding } from '@/components/Landing/LandingKit';
import {
  CLOSING_MARKS,
  CLOSING_TRUST,
  CONTACT_EMAIL,
} from '@/constants/enterpriseContent';

function EnterpriseClosing() {
  const { display } = useLanding();
  const headline = display({ min: 34, max: 70, leading: 0.98, tracking: -0.042 });

  return (
    <ClosingBand
      label="Start an enterprise engagement"
      kicker="Let's scope it"
      lines={[
        ['Tell us the problem.'],
        [
          "We'll tell you what it ",
          <Accent key="a" size={headline.fontSize} leading={headline.lineHeight}>takes</Accent>,
          '.',
        ],
      ]}
      lede="Send us the problem you are trying to solve and the constraints you are working within. We will come back with an approach, a timeline, and a number."
      marks={CLOSING_MARKS}
      trust={CLOSING_TRUST}
      primary={{ label: 'Schedule a consultation', href: '/contact' }}
      secondary={{
        label: CONTACT_EMAIL,
        icon: 'envelope',
        onPress: () => Linking.openURL(`mailto:${CONTACT_EMAIL}`),
      }}
      showStores={false}
    />
  );
}

export default React.memo(EnterpriseClosing);
